import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { UserService } from "../_services/user-service/user.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { UserData } from "../_models/userData";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit, OnDestroy {
  public errorMessage: string;
  public forceLogoutAndLoginBoolean: boolean = false;

  loginForm = new FormGroup({
    username: new FormControl("", [Validators.required]),
    password: new FormControl("", Validators.required),
  });

  constructor(
    @Inject(DOCUMENT) private _document,
    private userService: UserService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient
  ) {}

  ngOnInit() {
    this._document.body.classList.add("login-body");
    localStorage.clear();
  }

  ngOnDestroy() {
    // remove the class form body tag
    this._document.body.classList.remove("login-body");
    localStorage.removeItem("userData");
  }

  login() {
    this.errorMessage = null;

    let username: string = this.loginForm.value.username;
    let password: string = this.loginForm.value.password;

    this.userService.setAuthToken(username, password);

    this.userService.login().subscribe(
      (response: HttpResponse<any>) => {

        this.userService.getUserInfo().subscribe((response: UserData) => {
          console.error("User data from user service: ", response);
          this.userService.setUserInfo(response);
          this.router.navigate(["/home"], {});
        })
      },
      (error: any) => {
        this.errorMessage = error.error.Message;
        if(this.errorMessage === "The user is already authenticated from another client."){
          this.forceLogoutAndLoginBoolean = true;
        }
      }
    );
  }

  forceLogoutAndLogin(){
    console.log("The method is called");

    this.userService.logout().subscribe(() => {
      this.userService.removeToken();
      this.router.navigate(['']);
      localStorage.clear();
      this.login();
    }, (error) => {
      error.console.error();
    });

  }
}
